<template>
  <div class="panel-container">
    <div class="panel-search__container">
      <div class="panel-search" @keyup.enter="getUsers(1, search)">
        <Input
          placeholder="Search by user"
          style="width:316px;marginBottom:15px"
          v-model="search"
          @keyup.enter="getUsers(1, search)"
        ></Input>
        <div class="search-button"><Icon type="md-search" size="24" style="cursor:pointer" @click="getUsers(1, search)" /></div>
      </div>
    </div>
    <div class="table" >
      <Table border
             :columns="columns4"
             :data="users"
             :loading=loading
             :no-data-text="noData"
             class="table__admin"
      >
      </Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page :total="totalUsers"
                  :current="current"
                  @on-change="changePage"
                  :page-size=limit
            >
            </Page>
        </div>
    </div>
    </div>
  </div>
</template>


  <script>
  import moment  from 'moment/min/moment-with-locales'

  import Download from '../components/Download';
  import ActionInTable from '../components/ActionInTable';
  import Automatic from '../components/AutoVerification';
  import InputBalance from '../components/InputBalance';
  import IconDelet from '../components/IconDelet';
  import ButtonSendCoin from '../components/ButtonSendCoin.vue';
  import TermsConditions from "../components/TermsConditions";
  import TransactionType from "../components/TransactionType";
  import EditWallet from "../components/EditWallet";

  export default {
      components: {
        Download, ActionInTable, Automatic, InputBalance, IconDelet, ButtonSendCoin
      },
        data() {
            return {
                noData: 'No data',
                limit: 15,
                offset: 0,
                search: '',
                columns4: [

                    {
                        title: 'Request date',
                        key: 'registration_date',
                        minWidth: 140,
                        render: (h, params) => {
                          let locale = window.navigator.userLanguage || window.navigator.language;
                          moment.locale(locale.toLowerCase())
                          return h('div', moment(params.row.registration_date).format("L LT"))
                        },
                    },
                    {
                        title: 'First name',
                        key: 'first_name',
                        minWidth:100
                    },
                    {
                        title: 'Last Name',
                        key: 'last_name',
                        className: 'table-header',
                        minWidth:100
                    },
                    {
                        title: 'Email',
                        key: 'email',
                        minWidth: 190,
                    },
                    {
                        title: 'Mobile Phone',
                        key: 'phone',
                        minWidth: 150,
                    },

                    {
                        title: 'BCR address',
                        key: 'bcr_address',
                        minWidth: 100,
                    },
                    {
                        title: 'BCR balance',
                        key: 'bcr_balance',
                        minWidth:90
                    },
                    {
                        title: 'Requested TPR balance',
                        key: 'bcr_request_balance',
                        minWidth:100,
                        render: (h, params) => {
                          return h(InputBalance, {props: params})
                        }
                    },
                    {
                        title: 'Total amount of sent TPR',
                        key: 'bcr_sent_amount',
                        minWidth: 105,
                        align: 'center',

                    },
                    {
                        title: 'TPR address',
                        key: 'tpr_address',
                        minWidth: 220,
                        render: (h, params) => {
                          return h(EditWallet, {
                            props: params,
                            on: {
                              changeAddress:this.changeWalletAddress
                            }
                          })
                        }
                    },
                    {
                      title: 'T&C',
                      key: 'terms_agree',
                      minWidth: 65,
                      align: "center",
                      render: (h, params) => {
                        return h(TermsConditions, {props: {...params, type:"terms"}} )
                      }
                    },
                    {
                      title: 'White paper',
                      key: 'whitepaper_agree',
                      minWidth: 85,
                      align: "center",
                      render: (h, params) => {
                        return h(TermsConditions, {props: {...params, type:"terms"}} )
                      }
                    },
                    {
                      title: 'Type',
                      key: 'type',
                      minWidth: 120,
                      align: "center",
                      render: (h, params) => {
                        return h(TransactionType, {props: params} )
                      }
                    },
                    {
                        title: 'KYC status',
                        key: 'status',
                        minWidth: 120,
                        render: (h, params) => {
                          return h(ActionInTable, {props: params} )
                        }
                    },
                    {
                        title: 'Send',
                        key: 'send',
                        minWidth: 77,
                        align: 'center',
                        render: (h, params) => {
                          return h(ButtonSendCoin, {props: params} )
                        }
                    },

                    {
                        title: 'Delete',
                        key: 'delete',
                        minWidth: 90,
                        render: (h, params) => {
                          return h(IconDelet, {props: params} )
                        }
                    },
                ],

            }
        },
        computed: {
          current() {
            const urlParams = new URLSearchParams(window.location.search);
            const page = urlParams.get('page');
            return +page || 1
          },
          users() {
            return this.$store.getters.getAdminUsers
          },
          totalUsers() {
            return this.$store.getters.getTotalUsers
          },

          loading() {
            return this.$store.getters.loading
          }
        },
        mounted() {
          const urlParams = new URLSearchParams(window.location.search);
          const page = urlParams.get('page');
          const search = urlParams.get('search');
          this.getUsers((page||1), search)
        },
        methods: {
          changeWalletAddress({id, tpr_address}) {
            this.users.forEach(el => {
              if (el.id == id) {
                el.tpr_address = tpr_address
              }
            });
          },
          changePage (page) {
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.set("page", page);
            if (this.search != '') {
              searchParams.set("search", this.search);
            }
            window.location.search = searchParams.toString();
            this.getUsers((page||1), this.search)
          },
          getUsers(page, value) {
            this.$store.dispatch('getUsersAdmin', {offset: (page-1) * this.limit, limit: this.limit, value})
            .then(res => {
              console.log(res.data.users)
            })
            .catch(err => {
              let error = err.response
              if (error.status == 401) {
                localStorage.removeItem('token')
                this.$router.push('/admin')
              }
            })
          },

        }
    }
</script>

<style lang="scss" scoped>

.panel-container {
  width: 100%;
  padding: 20px 0;
  .panel-search__container {
    display: flex;
    justify-content: space-between;
    .panel-search {
      display: flex;

      .search-button {
        width: 36px;
        height: 36px;
        background: #FADB08;
        border-radius: 4px;
        margin-left: 5px;
        margin-top: -2px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .panel-action-btn {
      display: flex;
      .ok {
        width: 36px;
        height: 36px;
        background: #35C030;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;
      }
      .cancel {
        width: 36px;
        height: 36px;
        background: #F65858;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;
      }
    }
  }
  .table {
    &__admin {
      //overflow-x: scroll;
      width: 100%;

    }
    .table-header {
      color:white;
    }
  }
}
</style>
